/* istanbul ignore file */

export const WIDGET_DIRECTORY_ENTRIES_TYPE = 'directory-entry';
